import api from "./api";
import { GetRetornoDto } from "../shared/dtos/Retorno.dto";
import { ResultDto } from "../shared/dtos/Result.dto";

class RetornoService {
  static async getAll(
    page: number,
    take: number
  ): Promise<{ data: GetRetornoDto[]; total: number }> {
    try {
      const response = await api.get(`retornos/get-all/${page}/${take}`);

      return response.data as { data: GetRetornoDto[]; total: number };
    } catch (error) {
      console.error("Erro ao buscar os retornos:", error);
      return { data: [], total: 0 };
    }
  }

  static async getBySearch(
    search: string,
    page: number,
    take: number
  ): Promise<{ data: GetRetornoDto[]; total: number }> {
    try {
      const response = await api.get(`retornos/get-by-search/${search}/${page}/${take}`);

      return response.data as { data: GetRetornoDto[]; total: number };
    } catch (error) {
      console.error("Erro ao buscar os retornos:", error);
      return { data: [], total: 0 };
    }
  }

  static async cancelEntryRetorno(id: number): Promise<ResultDto> {
    try {
      const response = await api.get(
        `/retornos/cancel-entry/${id}`,
        {
          timeout: 0,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data as ResultDto;
    } catch (error) {
      console.error("Erro ao cancelar a entrada:", error);
      return { success: false, message: "Erro ao cancelar a entrada" };
    }
  }
}

export default RetornoService;
